import { REPORT_FAILURE, REPORT_REQUEST, REPORT_SUCCESS, ReportActionTypes, ReportState } from "@store/actions/common/fileExport/fileExportTypes";

const initialState: ReportState = {
    data: null,
    loading: false,
    error: null,
};

const reportReducer = (
    state: ReportState = initialState,
    action: ReportActionTypes
): ReportState => {
    switch (action.type) {
        case REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: null,
            };
        default:
            return state;
    }
};

export default reportReducer;